export function convertEmptyStringToNull(value: number | string): null | string | number {
  if (value === '') return null;
  return value;
}
